// eslint-disable-next-line import/prefer-default-export
export const UPDATE_EMPLOYEE_APP_DATA = 'UPDATE_EMPLOYEE_APP_DATA';
export const UPDATE_DASHBOARD_FILTERS_APP_DATA = 'UPDATE_DASHBOARD_FILTERS_APP_DATA';
